import React from 'react';
import PropTypes from 'prop-types';
import RouteWithLayoutV2 from './components/RouteWithLayoutV2';
import { MainV2 as MainV2Layout } from './components/layouts';
import {
  ConvocacaoV2 as ConvocacaoView,
  PedidoVooV2 as PedidoVooView,
  OleriteV2 as OleriteView,
  NotasV2 as NotasView,
  CartoesV2 as CartoesView,
  InspecaoVeicularV2 as InspecaoVeicularView,
  MalhasV2 as MalhasView,
  GerenciasV2 as GerenciasView,
  PolosV2 as PolosView,
  SubestacoesV2 as SubestacoesView,
  AlimentadoresV2 as AlimentadoresView,
  DocumentosV2 as DocumentosView,
  AportesV2 as AportesView,
  AporteUsuarioV2 as AporteUsuarioView,
  EstoqueV2 as EstoqueView,
  EstoquePedidosV2 as EstoquePedidosView,
  EstoqueProdutosV2 as EstoqueProdutosView,
} from '../views/v2';

const RoutesV2 = ({ match, modeSetting, resolvedMode, onModeSettingChange }) => (
  <>
    <RouteWithLayoutV2
      component={ConvocacaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/convocacoes`}
    />
    <RouteWithLayoutV2
      component={PedidoVooView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/pedidos-voo`}
    />
    <RouteWithLayoutV2
      component={OleriteView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/olerites`}
    />
    <RouteWithLayoutV2
      component={NotasView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/notas`}
    />
    <RouteWithLayoutV2
      component={CartoesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/cartoes`}
    />
    <RouteWithLayoutV2
      component={InspecaoVeicularView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/inspecoes-veiculares`}
    />
    <RouteWithLayoutV2
      component={MalhasView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/malhas`}
    />
    <RouteWithLayoutV2
      component={GerenciasView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/gerencias`}
    />
    <RouteWithLayoutV2
      component={PolosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/polos`}
    />
    <RouteWithLayoutV2
      component={SubestacoesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/subestacoes`}
    />
    <RouteWithLayoutV2
      component={AlimentadoresView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/alimentadores`}
    />
    <RouteWithLayoutV2
      component={DocumentosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/documentos`}
    />
    <RouteWithLayoutV2
      component={AportesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/aportes`}
    />
    <RouteWithLayoutV2
      component={AporteUsuarioView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/aporte/:usuarioId`}
    />
    <RouteWithLayoutV2
      component={EstoqueView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/estoques`}
    />
    <RouteWithLayoutV2
      component={EstoquePedidosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/estoque/pedidos`}
    />
    <RouteWithLayoutV2
      component={EstoqueProdutosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/estoque/produtos`}
    />
  </>
);

RoutesV2.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  modeSetting: PropTypes.oneOf(['system', 'light', 'dark']).isRequired,
  resolvedMode: PropTypes.oneOf(['light', 'dark']).isRequired,
  onModeSettingChange: PropTypes.func.isRequired,
};

export default RoutesV2;
